// Tastenkürzel zum Neuladen, passend zum Gerät.
//
// Wird in allen Hinweisen benutzt, die dem Team im Zweifel sagen sollen
// „einmal neu laden" — auf dem Mac ist das ⌘R, auf Windows F5. Ohne die
// Unterscheidung steht in der Meldung ein Kürzel, das bei der Hälfte des
// Teams nichts tut.

interface UserAgentDataLike { platform?: string }

export function istMac(): boolean {
  if (typeof navigator === 'undefined') return false;
  const daten = (navigator as Navigator & { userAgentData?: UserAgentDataLike }).userAgentData;
  if (daten?.platform) return /mac/i.test(daten.platform);
  return /Mac|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/** „⌘R" bzw. „F5" — für Fließtext in Hinweisen. */
export function neuLadenTaste(): string {
  return istMac() ? '⌘ + R' : 'F5';
}
